import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../enums/Paths";
import { useSelector } from "react-redux";
import * as loginActions from "../store/actions/login";
import { useAppDispatch } from "..";
import { getCodigoByDescricao, Roles } from "../enums/Roles";
import { getCallbackPathFromRole } from "../helpers/HelperFunctions";

const Landing = ({ ...props }) => {
  // Essa é uma página de exemplo. É a landing page da aplicação (O endereço /) que não é protegida
  // e não necessita de um usuário logado. Pode ser utilizada como página de login e, a partir dela, .
  // redirecionar para uma página Home
  // Colocar um botão de login aqui pra poder manter o token nos cookies do navegador
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { token } = useSelector((state: any) => state.login);
  const { userInfo } = useSelector((state: any) => state.login);
  const { tokenType } = useSelector((state: any) => state.login);
  const { currentProfile } = useSelector((state: any) => state.login);

  const updateUserInfo = useCallback(async () => {
    await dispatch(loginActions.updateUserInfo());
  }, []);

  const logout = useCallback(async ()=>{
    await dispatch(loginActions.logout())
  }, []);

  useEffect(() => {
    //Redirecionando para listagem de empresas ao entrar na tela caso esteja logado
    if (token !== null) {
      if (tokenType === "reset_password") {
        navigate(Paths.ChangePassword, { state: { isPrimeiroAcesso: true } });
      } else {
        updateUserInfo();
        const isAllQuestionnariesFinished =
          userInfo.questionarios.filter((q: any) => {
            return (
              q.avaliacaoRespondida === null ||
              !q.avaliacaoRespondida.finalizada
            );
          }).length === 0;

        const isCadastroIncompleto = userInfo.cadastroIncompleto;

        if (isCadastroIncompleto) {
          navigate(Paths.InformationComplementary);
        } else {
          if (isAllQuestionnariesFinished) {
            const navigationPath = getCallbackPathFromRole(currentProfile)
            navigate(navigationPath);
          } else {
            navigate(Paths.OMSQuestionnaire);
          }
        }
      }
    }
  }, []);

  return <></>;
};

export default Landing;
